import { TOKEN_EXPIRATION_DATE } from "../constants/localStorage/localStorage.constants";
import { getItem } from "./localStorage.utils";

const base64UrlDecode = str => {
  const normalized = str.replace(/-/g, "+").replace(/_/g, "/");
  const padded = normalized.padEnd(
    normalized.length + ((4 - (normalized.length % 4)) % 4),
    "="
  );
  return atob(padded);
};

const SKEW_MS = 5000;

const readJwtExp = token => {
  if (!token || typeof token !== "string") return null;
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    const payload = JSON.parse(base64UrlDecode(parts[1]));
    return typeof payload.exp === "number" ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
};

const readStoredExp = () => {
  const raw = getItem(TOKEN_EXPIRATION_DATE);
  if (raw === null || raw === undefined) return null;
  // Accept unix seconds, unix ms, or ISO strings
  if (typeof raw === "number") return raw < 1e12 ? raw * 1000 : raw;
  const parsed = Date.parse(raw);
  return Number.isNaN(parsed) ? null : parsed;
};

export const isJwtExpired = token => {
  const now = Date.now();
  const jwtExpMs = readJwtExp(token);
  const storedExpMs = readStoredExp();

  if (jwtExpMs === null && storedExpMs === null) {
    // No expiry info anywhere — if we have a token string at all, can't know; treat as expired to force refresh
    return !token || typeof token !== "string" || token.split(".").length !== 3;
  }

  if (jwtExpMs !== null && now >= jwtExpMs - SKEW_MS) return true;
  if (storedExpMs !== null && now >= storedExpMs - SKEW_MS) return true;
  return false;
};
